import {decorateInnerElements, disposeInnerComponents} from 'fg-frontend/src/webComponents/decorate';

var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'webslider';

var DEFAULTS = {
  dataSource: null,
};


/**
 * constructor
 * @param selector
 * @param options
 * @constructor
 */
var Webslider = function (selector, options) {
  this.$t = $(selector);

  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.data = {};
  this.objects = {};
  this.animating = false;

  this.initialise_();
};

/**
 * init funkce
 * @private
 */
Webslider.prototype.initialise_ = function () {
  var self = this;

  self.getData_();

  if (self.data.length > 0) {
    self.objects.$preloader = self.$t.find('.preloader');
    self.buildHtml_();
    self.bindEvents_();
  }
};

Webslider.prototype.getData_ = function () {
  var self = this;
  self.data = self.options.dataSource
};

Webslider.prototype.buildHtml_ = function () {
  var self = this;
  if (self.data.length > 1) {
    self.buildHtmlThumbnailsWrapper_();
  }
  self.buildHtmlContent_();
};


Webslider.prototype.buildHtmlThumbnailsWrapper_ = function () {
  var self = this;

  self.objects.$slideThumbnails = $('<div class="series-webslider__thumbnails" />');
  self.objects.$slideThumbnailsList = $('<ul id="series-webslider__thumbnails-list" class="series-webslider__thumbnails-list" />');
  self.$t.append(self.objects.$slideThumbnails);
  self.objects.$slideThumbnails.append(self.objects.$slideThumbnailsList);
};

Webslider.prototype.buildHtmlContent_ = function () {
  var self = this,
    item,
    thumbnailClass,
    slideClass,
    html = '',
    $mainMotiveSlide,
    showMoreBtn;

  self.objects.$slideWrapper = self.$t.find('.series-webslider-wrapper');

  for (var i in self.data) {
    item = self.data[i];
    thumbnailClass = '';
    slideClass = '';

    if (i == 0) {
      thumbnailClass = ' active';
    }

    if (item.type == 'mainMotive') {
      $mainMotiveSlide = self.objects.$slideWrapper.find('.slide');
      $mainMotiveSlide.attr('data-item-id', i);
      self.buildHtmlProducts_($mainMotiveSlide, item.data);
    } else {
      slideClass = item.type == 'video' ? ' slide--video' : '';
      html = '<div class="slide' + slideClass + '" data-item-id="' + i + '">';
      if (item.type == 'galleryItem') {
        //html += '<picture><source data-srcset="' + item.src + '" media="(min-width: 941px)"><img class="series-webslider__img" src="' + item.srcSm + '" alt=""></picture>';
        html += '<img class="slide__motive" src="' + item.src + '" alt="Obrázek-detail série">';
      } else if (item.type == 'video') {
        thumbnailClass += ' series-webslider__thumb-item--video';
        html += '<iframe class="series-webslider__iframe" id="yt-player" type="text/html" width="100%" height="100%" src="http://www.youtube.com/embed/' + item.videoCode + '?enablejsapi=1" frameborder="0"></iframe>';
      }
      html += '</div>';
      self.objects.$slideWrapper.append(html);
    }

    self.objects.$slides = self.objects.$slideWrapper.find('.slide');

    if (self.data.length > 1) {
      self.objects.$slideThumbnailsList.append('<li class="series-webslider__thumb-item' + thumbnailClass + '" data-item-id="' + i + '"><a href="#" class="series-webslider__thumb-link"><img class="series-webslider__thumb-img" src="' + item.srcThumb + '" alt="" /><span></span></a></li>');
    }
  }

  if (self.data.length > 1) {
    self.objects.$sliderArrowContainer = $('<span class="series-webslider__controls"/>');
    self.objects.$sliderArrowPrev = $('<span class="series-webslider__controls-item series-webslider__controls-item--prev"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#left"></use></svg></span>').appendTo(self.objects.$sliderArrowContainer);
    self.objects.$sliderArrowNext = $('<span class="series-webslider__controls-item series-webslider__controls-item--next"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#right"></use></svg></span>').appendTo(self.objects.$sliderArrowContainer);
    self.objects.$slideWrapper.append(self.objects.$sliderArrowContainer);
    self.objects.$thumbnails = self.objects.$slideThumbnailsList.find('li');
    self.objects.$thumbnailsLinks = self.objects.$slideThumbnailsList.find('a');
    self.objects.$ytPlayer = self.objects.$slideWrapper.find('#yt-player');

    setTimeout(function () {
      decorateInnerElements(self.objects.$slideThumbnails[0]);
      self.objects.$slideThumbnailsList.addClass('visible');
    }, 2000);
  }
};

Webslider.prototype.buildHtmlProducts_ = function ($wrapper, data) {
  var self = this,
    item,
    coords,
    img = $wrapper.find('img').get(0),
    imgProduct = '';

  self.objects.$productsList = $('<ul class="point-list" />');
  $wrapper.append(self.objects.$productsList);

  for (var i in data) {
    item = data[i];

    if (item.productLink != null && item.productLink != '' && item.coordinateX != '' && item.coordinateY != '') {
      coords = self.getCoords_(item.coordinateX, item.coordinateY, item.coordinateWidth, item.coordinateHeight);
      self.objects.$productsList.append('' +
        '<li class="point-list__item">' +
          '<span class="point-list__point"' + coords + '>' +
            '<svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#eye"></use></svg>' +
            '<svg class="svg-icon svg-icon--active"><use xlink:href="/build/img/svg/svg-sprite.svg#eye-over"></use></svg>' +
          '</span>' +
          '<div class="point-list__tooltip noPartialUpdate">' +
            '<button type="button" aria-label="Zavři okno" class="point-list__tooltip-close"><span class="sr-only">Zavři okno</span></button>' +
            '<div class="point-list__info">' +
              '<img class="point-list__info-motive" src="' + item.productImg + '"/>' +
              '<h2 class="point-list__info-title">' + item.productName + '</h2>' +
              '<p class="point-list__info-variant">' + item.productDimensions + '</p>' +
              '<div class="point-list__info-price-container">' +
                '<p class="point-list__info-referenced-price">' + item.productReferencePrice + '</p>' +
                '<p class="point-list__info-price">' + item.productPrice + '</p>' +
              '</div>' +
              '<p class="point-list__info-link-container">' +
                '<a class="btn btn--primary point-list__info-link" href="' + item.productLink + '">' + self.options.localeButton + '</a>' +
              '</p>' +
          '</div>' +
        '</li>'
      );
    }
  }
  self.objects.$products = self.objects.$productsList.find('.point-list__point');

  // close button
  self.objects.$productsClose = self.objects.$productsList.find('.point-list__tooltip-close');

  self.objects.$products.each(function (i) {
    var $point = $(this);

    var timeout1 = setTimeout(function () {
      $point.addClass('animate');
    }, i * 500 + 1000);

    var timeout2 = setTimeout(function () {
      $point.removeClass('animate');
    }, i * 500 + 1600);
  });
};

Webslider.prototype.getCoords_ = function (x, y, imgWidth, imgHeight) {
  var self = this,
    relativeX,
    relativeY;

  if (!imgWidth) {
    imgWidth = '1610';
  }
  if (!imgHeight) {
    imgHeight = '831';
  }

  x = parseInt(x.replace(',', '.'));
  y = parseInt(y.replace(',', '.'));
  imgWidth = parseInt(imgWidth.replace(',', '.'));
  imgHeight = parseInt(imgHeight.replace(',', '.'));

  if ((imgWidth > 0) && (imgHeight > 0)) {
    relativeX = (x * 100) / imgWidth;
    relativeY = (y * 100) / imgHeight;
  } else {
    relativeX = x;
    relativeY = y;
  }

  return ' style="left: ' + relativeX + '%; top: ' + relativeY + '%"';
};

Webslider.prototype.isTouchDevice_ = function () {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
};

Webslider.prototype.bindEvents_ = function () {
  var self = this;

  if (self.data.length > 1) {
    self.objects.$thumbnailsLinks.on('click', function (e) {
      self.setActiveSlide_($(this).parents('li').attr('data-item-id'));
      e.preventDefault();
    });

    self.objects.$sliderArrowPrev.on('click', function (e) {
      self.setActiveSlide_(self.getPrevSlide_());
      e.preventDefault();
    });

    self.objects.$sliderArrowNext.on('click', function (e) {
      self.setActiveSlide_(self.getNextSlide_());
      e.preventDefault();
    });

    // Keep track of how many swipes
    var swipeCount = 0; // Creating counter

    // detect swipe events
    self.objects.$slides.swipe({

      allowPageScroll: "auto",

      //Generic swipe handler for all directions
      swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
        // swipe left with swipe count adjust
        if (direction == 'left') {
          ++swipeCount;
          if (swipeCount < self.data.length) {
            self.setActiveSlide_(swipeCount);
          } else {
            swipeCount = self.data.length - 1;
          }
        }
        // swipe right with swipe count adjust
        if (direction == 'right') {
          --swipeCount;
          if (swipeCount < self.data.length && swipeCount >= 0) {
            self.setActiveSlide_(swipeCount);
          } else {
            swipeCount = 0;
          }
        }
      }
    })
  }


  /**
   * Products are actualy span elements as I need to distribute click event on the close button as well
   */
  self.objects.$products.on('click', function (e) {
    self.objects.$productsList.find('li').removeClass('active');
    $(this).parent('li').addClass('active');

    //self.toggleProduct_($(this));

    /*if (self.objects.$productsList.find('li.active').length > 0) {
      self.$t.addClass('enter');
    } else {
      self.$t.removeClass('enter');
    }*/

  });


  // close the popup
  self.objects.$productsClose.on('click', function (e) {
    self.objects.$productsList.find('li.active').removeClass('active');
  });

  /*if (!this.isTouchDevice_()) {
    self.objects.$products.on('mouseenter', function (e) {
      self.$t.addClass('enter');
      self.toggleProduct_($(this));
    }).on('mouseleave', function (e) {
      $(this).removeClass('in-progress');
      self.$t.removeClass('enter');
      self.toggleProduct_($(this));
    })
  } else {
    self.objects.$products.on('click', function (e) {
      self.toggleProduct_($(this));

      if (self.objects.$productsList.find('li.active').length > 0) {
        self.$t.addClass('enter');
      } else {
        self.$t.removeClass('enter');
      }

    });
  }*/

  self.objects.$slides.children('img, iframe').on('load', function () {

    var $this = $(this),
      thisItemId = $this.parents('.slide').attr('data-item-id');

    $this.attr('data-loaded', true);

    if (self.preloaderReasonId == thisItemId) {
      self.finishSettingActiveSlide_(self.preloaderReasonId);
    }
  });
};

Webslider.prototype.setActiveSlide_ = function (id) {
  var self = this,
    $currentTarget = self.objects.$slides.filter('.active'),
    currentTargetId = $currentTarget.attr('data-item-id'),
    $newTarget = self.objects.$slides.filter('[data-item-id=' + id + ']');


  if ((id != currentTargetId) && (!self.animating)) {
    // stop yt video playback
    if (self.objects.$ytPlayer.length > 0) {
      var frame = self.objects.$ytPlayer.get(0);
      frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
    if ($newTarget.children('img, iframe').is('[data-loaded]')) {
      self.finishSettingActiveSlide_(id);
    } else {
      self.startPreloader_(id);
    }
  }
};

Webslider.prototype.finishSettingActiveSlide_ = function (id) {
  var self = this,
    $currentTarget = self.objects.$slides.filter('.active'),
    currentTargetId = $currentTarget.attr('data-item-id'),
    $newTarget = self.objects.$slides.filter('[data-item-id=' + id + ']'),
    animatingClass = 'animating-from-right';

  self.animating = true;

  if (self.preloaderReasonId > -1) {
    self.endPreloader_();
  }

  if (id < currentTargetId) {
    animatingClass = 'animating-from-left';
  }

  self.objects.$thumbnails.removeClass('active').filter('[data-item-id=' + id + ']').addClass('active');
  $currentTarget.addClass('animating-hiding');
  $newTarget.addClass(animatingClass);
  $newTarget.one('animationend webkitAnimationEnd oAnimationEnd', function () {
    $currentTarget.removeClass('active').removeClass('animating-hiding');
    $newTarget.removeClass(animatingClass).addClass('active');
    self.animating = false;
  });
};

/*Webslider.prototype.toggleProduct_ = function ($element) {
  var self = this,
    $item = $element.find('.point-list__tooltip'),
    itemWidth,
    itemHeight,
    itemOffsetLeft,
    itemOffsetTop,
    wrapperWidth,
    wrapperHeight;

  $element.removeClass('active-left active-top').toggleClass('active');

  if ($element.hasClass('active')) {
    itemWidth = $item.outerWidth(true);
    itemHeight = $item.outerHeight(true);
    itemOffsetLeft = $item.parents('li').position().left;
    itemOffsetTop = $item.parents('li').position().top;
    wrapperWidth = self.objects.$productsList.width();
    wrapperHeight = self.objects.$productsList.height();

    if ((itemOffsetLeft + itemWidth) >= wrapperWidth) {
      $element.addClass('active-left');
    }
    if ((itemOffsetTop + itemHeight) >= wrapperHeight) {
      $element.addClass('active-top');
    }
  }
};*/
Webslider.prototype.getPrevSlide_ = function () {
  var self = this,
    $previousItem = self.objects.$thumbnails.filter('.active').prev('li');

  if (!$previousItem.length) {
    $previousItem = self.objects.$thumbnails.filter('li:last-child');
  }

  return $previousItem.attr('data-item-id');
};

Webslider.prototype.getNextSlide_ = function () {
  var self = this,
    $nextItem = self.objects.$thumbnails.filter('.active').next('li');

  if (!$nextItem.length) {
    $nextItem = self.objects.$thumbnails.filter('li:first-child');
  }

  return $nextItem.attr('data-item-id');
};


Webslider.prototype.startPreloader_ = function (reasonId) {
  var self = this;
  self.objects.$preloader.show();
  self.preloaderReasonId = reasonId;
};
Webslider.prototype.endPreloader_ = function () {
  var self = this;
  self.objects.$preloader.hide();
  self.preloaderReasonId = null;
};


/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  var args = arguments;

  return this.each(function () {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if (!plugin) {
      plugin = new Webslider(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/third/jquery.webslider.js